module.exports = __webpack_public_path__ + "images/4e2d8e89bdd27855cecf668864e2c320.png";